/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ServerInformation } from '../models/server-information';
@Injectable({
  providedIn: 'root',
})
class ServerInformationService extends __BaseService {
  static readonly ServerInformationGetPath = '/server-information';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Returns server information
   * @return OK
   */
  ServerInformationGetResponse(): __Observable<__StrictHttpResponse<ServerInformation>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/server-information`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ServerInformation>;
      })
    );
  }
  /**
   * Returns server information
   * @return OK
   */
  ServerInformationGet(): __Observable<ServerInformation> {
    return this.ServerInformationGetResponse().pipe(
      __map(_r => _r.body as ServerInformation)
    );
  }
}

namespace ServerInformationService {
}

export { ServerInformationService }